import { makeStyles } from "@material-ui/core/styles";
import { ReactNode } from "react";
import { rv } from "../tokens";
import { LockIcon } from "./icons";
import StatusPill from "./StatusPill";

const useStyles = makeStyles((theme) => ({
  card: {
    background: rv.card,
    border: `1.5px solid ${rv.hairline}`,
    borderRadius: rv.radiusCard,
    boxShadow: rv.shadowCard,
    marginBottom: theme.spacing(2.5),
    overflow: "hidden",
  },
  header: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1.5),
    padding: theme.spacing(2, 2.75, 0),
  },
  iconTile: {
    width: 37,
    height: 37,
    flexShrink: 0,
    borderRadius: 10,
    background: rv.mint2,
    color: rv.green,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  title: {
    fontWeight: 700,
    fontSize: 15,
    color: rv.heading,
    flexGrow: 1,
  },
  body: {
    padding: theme.spacing(2, 2.75, 2.75),
  },
  helper: {
    display: "flex",
    alignItems: "center",
    gap: 6,
    marginTop: theme.spacing(1.5),
    color: rv.muted,
    fontSize: 12,
  },
}));

interface Props {
  title: string;
  icon?: ReactNode;
  verified?: boolean;
  helperNote?: string;
  children: ReactNode;
}

export default function SectionCard({
  title,
  icon,
  verified,
  helperNote,
  children,
}: Props) {
  const classes = useStyles();
  return (
    <section className={classes.card}>
      <div className={classes.header}>
        {icon && <span className={classes.iconTile}>{icon}</span>}
        <span className={classes.title}>{title}</span>
        {verified && (
          <StatusPill tone="verified" icon={<LockIcon size={12} />}>
            Verified
          </StatusPill>
        )}
      </div>
      <div className={classes.body}>
        {children}
        {helperNote && (
          <p className={classes.helper}>
            <LockIcon size={13} color={rv.muted} />
            {helperNote}
          </p>
        )}
      </div>
    </section>
  );
}
